/* eslint-disable prettier/prettier */
import Vue from "vue";
import Vuex from "vuex";
import randomColor from "randomcolor";
import serverInfo from './serverinfo/'

// Added jquery
import $ from "jquery";
window.$ = $;

Vue.use(Vuex);

const SERVER_BASE_URL = serverInfo.SERVER_BASE;

function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

let convertColor = hex => {
  if (hex.substring(0, 1) == "#") {
    hex = hex.substring(1);
  }

  return {
    r: parseInt(hex.substring(0, 2), 16),
    g: parseInt(hex.substring(2, 4), 16),
    b: parseInt(hex.substring(4), 16)
  };
};

let colorDistance = (a, b) => {
  let diffR = a.r - b.r;
  let diffG = a.g - b.g;
  let diffB = a.b - b.b;
  return Math.sqrt(diffR * diffR + diffG * diffG + diffB * diffB);
};

function uniqueColor(existingColors) {
  let color = randomColor();

  let unique = false;
  let iterations = 0;
  if (existingColors.length) {
    while (iterations < 1000 && !unique) {
      color = randomColor();
      unique = existingColors.every(c => {
        let distance = colorDistance(convertColor(c), convertColor(color));
        return distance > 100;
      });
      iterations += 1;
    }
  }

  return color;
}

function brightness({ r, g, b }) {
  return (r * 299 + g * 587 + b * 114) / 1000;
}

function brighterThan(color, x) {
  let b = brightness(color);
  return b > x;
}

function textColor(color) {
  return brighterThan(convertColor(color), 123) ? "#333" : "#fff";
}

export default new Vuex.Store({
  state: {
    user: window.localStorage.getItem("user"),
    selectedUprights: null,
    selectedHeight: null,
    selectedBeam: null,
    doubleRack: false,
    selectedLevelCount: 3,
    selectedSectionCount: 1,
    assembledUprights: false,
    includeRackGuards: false,
    includeUprightProtectors: false,
    includeImpactProtectors: false,
    sectorOverload: false,

    dataAvailableUprights: [],
    dataAvailableBeams: [],
    dataRackGuards: [],
    dataUprightProtectors: [],
    dataImpactProtectors: [],
    dataDistances: [],

    sectors: []
  },

  getters: {
    getUserStatus: state => !!state.user,
    getUser: state => JSON.parse(state.user),

    availableUprights: state => {
      return state.dataAvailableUprights;
    },

    availableBeams: state => {
      return state.dataAvailableBeams;
    },

    rackGuards: state => {
      return state.dataRackGuards;
    },

    uprightProtectors: state => {
      return state.dataUprightProtectors;
    },

    impactProtectors: state => {
      return state.dataImpactProtectors;
    },

    distances: state => {
      return state.dataDistances;
    },

    availableHeights: state => {
      if (state.selectedUprights) return state.selectedUprights.options.map(o => o.height);
      return [];
    },

    selectedUpright: state => {
      if (state.selectedHeight) {
        let selectedUpright = state.selectedUprights.options.find(
            o => o.height == state.selectedHeight
        );

        if( selectedUpright )
          return selectedUpright;

        /*
          Alright, no matching selectedUpright, this can happen because the selected height wasn't available if we selected a capacity
          that didn't have that tall/short uprights. In that case we revert to the default selected upright
        */
        return state.selectedUprights.options.find(
            o => o.height > 2500
        );
      }
    },

    setSectorOverload: (state, sector) => {
      let sectorOverload = (this.selectedUprights.maxLoad /
          (sector.levelCount * sector.beam.pallets) < sector.beam.loadCapacity);

      this.sectorOverload = sectorOverload

      return sectorOverload;
    },

    totalPallets: state => {
      let count = 0;
      state.sectors.forEach(sector => {
        count += sector.beam.pallets * Number(sector.levelCount) + sector.beam.pallets;
      });
      return count;
    },

    totalWidth: (state, getters) => {

      // TODO Move all width related logic here
      let width = 0;
      state.sectors.forEach((sector, index) => {
        width += getters.sectorWidth(index);
      });
      return width;
    },

    allowedSections: state => {
      // Evaluate for the first sector
      let sectorWidth = 0;
      if (state.sectors.length) {
          let sector = state.sectors[0];
          sectorWidth += (sector.beam.length + state.selectedUprights.width);
          sectorWidth += state.selectedUprights.width;
      }

      // TODO Possibly move this to a propper constant
      var maxWidth = 21000; // 20 meters but were using 21 for the calculations :)

      let allowedNumberOfSection = parseInt( Math.round(  maxWidth / sectorWidth ) );

      if(allowedNumberOfSection <= 0)
        allowedNumberOfSection = 1;

      return allowedNumberOfSection;
    },

    maxLevels: state => {
      if (!state.selectedHeight) return 0;
      return Math.ceil((state.selectedHeight / 1000) * 2);
    },

    sectorWidth: state => index => {
      let width = 0;
      if (state.sectors.length) {
        let sector = state.sectors[index];
        width +=
          (sector.beam.length + state.selectedUprights.width) *
          Number(sector.sectionCount);
        if (index === 0) width += state.selectedUprights.width;
      }
      return width;
    },

    sectorPosition: (state, getters) => index => {
      let position = 0;
      if (state.sectors.length && index) {
        for (let i = 0; i < index; i++) {
          position += getters.sectorWidth(i);
        }
        position -= state.selectedUprights.width;
      }
      return position;
    }
  },

  mutations: {
    updateSelectedUprights: (state, value) => {
      state.selectedUprights = value;
    },

    updateSelectedHeight: (state, value) => {
      state.selectedHeight = value;
    },

    updateSelectedBeam: (state, value) => {
      state.selectedBeam = value;
    },

    addSector: (state, sector) => {
      state.sectors.push(sector);
    },

    removeSector: (state, index) => {
      state.sectors.splice(index, 1);

      state.sectors.forEach((sector, index) => {
        sector.index = index;
      });
    },

    updateSector: (state, sector) => {
      let index = state.sectors.findIndex(s => s.id === sector.id);
      state.sectors[index] = sector;
    },

    updateSelectedLevelCount: (state, value) => {
      state.selectedLevelCount = value;
    },

    updateSelectedSectionCount: (state, value) => {
      state.selectedSectionCount = value;
    },

    updateDoubleRack: (state, value) => {
      state.doubleRack = value;
    },

    updateAssembledUprights: (state, value) => {
      state.assembledUprights = value;
    },

    updateIncludeUprightProtectors: (state, value) => {
      state.includeUprightProtectors = value;
    },

    updateIncludeRackGuards: (state, value) => {
      state.includeRackGuards = value;
    },

    updateIncludeImpactProtectors: (state, value) => {
      state.includeImpactProtectors = value;
    },

    setAvailableUprights: (state, value) => {
      state.dataAvailableUprights = value;
    },

    setAvailableBeams: (state, value) => {
      state.dataAvailableBeams = value;
    },

    setUprightProtectors: (state, value) => {
      state.dataUprightProtectors = value;
    },

    setImpactProtectors: (state, value) => {
      state.dataImpactProtectors = value;
    },

    setRackGuards: (state, value) => {
      state.dataRackGuards = value;
    },

    setDistances: (state, value) => {
      state.dataDistances = value;
    }
  },

  actions: {
    setHeight({ commit }, height) {
      commit("updateSelectedHeight", height);
    },

    addSector({ state, commit }) {
      let color = uniqueColor(state.sectors.map(s => s.backgroundColor));
      let sector = {
        id: uuidv4(),
        sectionCount: state.selectedSectionCount,
        levelCount: state.selectedLevelCount,
        beam: state.selectedBeam,
        index: state.sectors.length,
        backgroundColor: color,
        textColor: textColor(color),
        expanded: true
      };
      commit("addSector", sector);
    },

    removeSector({ commit }, index) {
      commit("removeSector", index);
    },

    requestData({ commit }) {
      // TODO Check if this is secure
      $.ajax({
        "url": SERVER_BASE_URL + "?cmd=loadconfig",
        "data": "",
        "method": "POST",
        "dataType": "json",
        /* eslint-disable-next-line */ // Added comment to avoid warnings because textStatus and xhr aren't used :)
        "success": function( data, textStatus, xhr ) {
          // NVM data.data :)
          var configData = data.data;

          commit( "setAvailableBeams", configData.available_beams );
          commit( "setAvailableUprights", configData.available_uprights );
          commit( "setDistances", configData.distances );
          commit( "setImpactProtectors", configData.impact_protectors );
          commit( "setRackGuards", configData.rackguards );
          commit( "setUprightProtectors", configData.upright_protectors );
        }
      });
    },
  }
});
